import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Close from "@material-ui/icons/Close";
import MateDriveService from "../../../../services/MateDriveService/MateDriveService";
const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "#f2f2f2",
    color: "#d6d6d6",
  },
  bottomSection: {
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  formControl: {
    backgroundColor: "#F2F2F2 !important",
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  button: {
    border: "none",
    borderRadius: "5px",
    width: 100,
    height: 35,
    float: "right",
    "&:focus": {
      outline: "none",
    },
  },
  submit: {
    color: "white",
    marginLeft: 15,
    backgroundColor: "#079063",
    cursor: "pointer",
  },
}));

const DeleteModal = ({ setOpen, setRender, selectItem, flowId, selectedItems }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
  };

  async function handleConfirm() {
    if (selectedItems.length > 0) {
      let path;
      let names = [];
      for (const item of selectedItems) {
        if (item?.path) {
          let findCharIndex = item.path.lastIndexOf('/');
          path = item.path.substr(0, findCharIndex);
          names.push(item.name);
        }
      }
      const resp = await MateDriveService.getFilterMateService('DELETEFILEFOLDER', path, names, '', flowId);
      if (resp?.status) {
        setRender(true);
        setOpen(false);
      }
    }
    else if (selectItem?.path !== null && selectItem?.path !== undefined) {
      let newPath;
      let findCharIndex = selectItem.path.lastIndexOf("/");
      newPath = selectItem.path.substr(0, findCharIndex);
      const resp = await MateDriveService.getFilterMateService(
        "DELETEFILEFOLDER",
        newPath,
        [selectItem.name],
        "",
        flowId
      );
      if (resp) {
        if (resp.status) {
          setRender(true);
          setOpen(false);
        }
      }
    }
  }
  return (
    <Dialog
      id="autom-addNew-modal"
      data-test="autom-add-new"
      open={true}
      onClose={handleClose}
      PaperProps={{
        style: {
          overflowX: "hidden",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <div id="about-title" style={{ justifyContent: "flex-end" }}>
          <Button
            data-test="cancelautom-button"
            onClick={handleClose}
          >
            <Close />
          </Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ textAlign: "left" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <p>{t("CONTENT.MATE-DRIVE.DELETE-CHOOSE")}</p>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: "space-between",
          padding: "8px 24px 16px 24px",
        }}
      >
        <button
          type="button"
          data-test="createautom-button"
          onClick={handleClose}
          className={`${classes.button} ${classes.submit}`}
          style={{
            backgroundColor: "#D75E5E",
            borderRadius: "2px",
            color: "#fff",
            border: "none",
          }}
        >
          {t("CONTENT.FLOW.NO")}
        </button>
        <button
          type="button"
          data-test="createautom-button"
          onClick={handleConfirm}
          className={`${classes.button} ${classes.submit}`}
          style={{
            backgroundColor: "#43AA41",
            borderRadius: "2px",
            color: "#fff",
            border: "none",
          }}
        >
          {t("CONTENT.FLOW.YES")}
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteModal;
